import { showClearAllButton } from "../../../config.js";

const validEndpoints = [
    'search',
    'search/funding-decisions',
    'search/resources',
    'search/resources/corporate-documents',
    'search/films',
    'search/news',
];

export const getQueryParam = (param) => new URLSearchParams(window.location.search).get(param);

export const updateQueryString = (input) => {
    const url = new URL(window.location);

    if (input instanceof HTMLFormElement) {
        // Update query string with form data
        const params = new URLSearchParams(new FormData(input));
        url.search = params.toString();
    } else if (typeof input === 'object' && input !== null) {
        // Update query string with key-value pairs
        Object.entries(input).forEach(([key, value]) => {
            if (value === null || value === undefined) {
                url.searchParams.delete(key);
            } else {
                url.searchParams.set(key, value);
            }
        });
    }

    history.pushState(null, '', url);
};

export const getApiUrl = (endpoint, form, formDataParsing = {}) => {
    if (!validEndpoints.includes(endpoint)) {
        throw new Error(`Invalid API endpoint: ${endpoint}`);
    }

    const baseUrl = new URL(`/api/${endpoint}`, window.location.origin);
    const formData = new FormData(form);

    for (const [key, value] of formData.entries()) {
        if (value) {
            baseUrl.searchParams.append(key, formDataParsing[key]?.(value) ?? value);
        }
    }

    return baseUrl;
};

export const fetchApiData = (url, onSuccess, onError) => {
    fetch(url)
        .then(response => response.json())
        .then(onSuccess)
        .catch(error => {
            console.error('Error fetching data:', error);
            if (onError) onError(error);
        });
};

export const showOrHideClearButton = (clearAllButton, searchForm, clearFormExclusions) => {
    if (!clearAllButton) return;
    const formData = new FormData(searchForm);
    let hasData = false;
    for (const key of formData.keys()) {
        if (formData.get(key) && !clearFormExclusions.includes(key)) {
            hasData = true;
            break;
        }
    }

    if (hasData) {
        clearAllButton.classList.add(showClearAllButton);
    } else {
        clearAllButton.classList.remove(showClearAllButton);
    }
}
